import fetchApi from "../fetchApi";

export const UpdateShippingAddress = async (
    id,
    status,
    office,
    name,
    firstName,
    lastName,
    company_id,
    address1,
    address2,
    postalCode,
    state,
    city,
    country,
    shippingMethod ) => {
    const options = {
        method: 'PUT',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "is_active": status,
            "office_id": office,
            "name": name,
            "first_name": firstName,
            "last_name": lastName,
            "company_id": company_id,
            "address": address1,
            "address_additional": address2,
            "postal_code": postalCode,
            "state": state,
            "city": city,
            "country": country,
            "shipping_method": shippingMethod
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/shipping-addresses/${id}`, options);
};